var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "26px",
    viewBox: "0 0 19 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Atoms",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Device-Search",
    transform: "translate(-7.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(8.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.2962963,
    y1: 21.4736842,
    x2: 10.0740741,
    y2: 21.4736842,
    id: "Path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 6.2962963,
    cy: 10.1052632,
    rx: 6.2962963,
    ry: 6.31578947
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7477778,
    y1: 14.5705263,
    x2: 17,
    y2: 20.8421053,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.2962963,
    y1: 21.4736842,
    x2: 10.0740741,
    y2: 21.4736842,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25925926,6.31578947 L1.25925926,1.89473684 C1.25925926,0.848368421 2.10500926,0 3.14814815,0 L13.2222222,0 C14.2653611,0 15.1111111,0.848368421 15.1111111,1.89473684 L15.1111111,15.1578947",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1111111,22.1052632 C15.1111111,23.1516316 14.2653611,24 13.2222222,24 L3.14814815,24 C2.10500926,24 1.25925926,23.1516316 1.25925926,22.1052632 L1.25925926,13.8947368",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDevices);
export default __webpack_public_path__ + "static/media/search-devices.5ea258d47be5b7b0769c7c3a55fdc9ab.svg";
export { ForwardRef as ReactComponent };